import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Table, Form, InputGroup } from 'react-bootstrap';
import { Eye } from 'lucide-react';
import { FaSearch, FaFilter,  } from 'react-icons/fa';

import Adminlayout from "../../../../layouts/admin/Adminlayout";
import '../../../../assets/css/admin/dashboardCSS/Disputes.css';
import TitleBar from '../../../../subscreens/admin/TitleBar';

const StudentDisputes = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('All');
  const [selectedDispute, setSelectedDispute] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Sample disputes data with "reportedBy" field
  const disputesData = [
    {
      id: 1,
      studentName: 'Ali Khan',
      donorName: 'Ahmed D.',
      reason: 'Fake requests',
      status: 'Pending',
      date: '08-01-2026',
      reportedBy: 'Donor',
      donorMessage: 'Ye student bar bar fake reason ke sath request bhej raha hai. Maine verify kiya hai aur ye genuine case nahi hai.',
    },
    {
      id: 2,
      studentName: 'Sara M.',
      donorName: 'Usman D.',
      reason: 'Harassment',
      status: 'Pending',
      date: '07-01-2026',
      reportedBy: 'Donor',
      donorMessage: 'Student repeatedly messaging and harassing for more donations. This behavior is unacceptable.',
    },
    {
      id: 3,
      studentName: 'Hassan Ali',
      donorName: 'Fatima D.',
      reason: 'Misleading information',
      status: 'Resolved',
      date: '05-01-2026',
      reportedBy: 'Student',
      donorMessage: 'Student provided false documents and misleading information about their financial situation.',
    },
    {
      id: 4,
      studentName: 'Ayesha Khan',
      donorName: 'Hope Foundation',
      reason: 'Payment not received',
      status: 'Pending',
      date: '10-01-2026',
      reportedBy: 'NGO',
      donorMessage: 'NGO complaint: Student received funds but did not provide proper acknowledgment and documentation.',
    },
    {
      id: 5,
      studentName: 'Ahmed Raza',
      donorName: 'Education Trust',
      reason: 'Misuse of funds',
      status: 'Pending',
      date: '12-01-2026',
      reportedBy: 'Student',
      donorMessage: 'NGO complaint: Funds were allocated for books but student used them for different purposes.',
    },
     {
       id: 6,
      studentName: 'Fatima Ali',
       donorName: 'Future Builders',
       reason: 'False documentation',
       status: 'Resolved',
       date: '09-01-2026',
       reportedBy: 'NGO',
       donorMessage: 'NGO complaint: Student submitted fake income certificates and forged documents.',
     },
  ];

  // Filter disputes based on search and filter type
  const filteredDisputes = disputesData.filter((dispute) => {
    const matchesSearch =
      dispute.studentName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      dispute.donorName.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesFilter = filterType === 'All' || dispute.reportedBy === filterType;
    
    return matchesSearch && matchesFilter;
  });

  // Pagination logic
  const totalPages = Math.ceil(filteredDisputes.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentDisputes = filteredDisputes.slice(startIndex, endIndex);

  // Reset to page 1 when search or filter changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, filterType]);

  // Pagination handlers
  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToPage = (page) => {
    setCurrentPage(page);
  };

  // Generate page numbers to display
  const getPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 5;
    
    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 5; i++) {
          pages.push(i);
        }
      } else if (currentPage >= totalPages - 2) {
        for (let i = totalPages - 4; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        for (let i = currentPage - 2; i <= currentPage + 2; i++) {
          pages.push(i);
        }
      }
    }
    
    return pages;
  };

  // Handle view details
  const handleViewDetails = (dispute) => {
    setSelectedDispute(dispute);
    setShowModal(true);
  };

  // Handle close modal
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedDispute(null);
  };

  // Handle warn student
  const handleWarnStudent = (studentName) => {
    alert(`Warning sent to ${studentName}`);
    handleCloseModal();
  };

  // Handle block student
  const handleBlockStudent = (studentName) => {
    if (window.confirm(`Are you sure you want to block ${studentName}?`)) {
      alert(`${studentName} has been blocked`);
      handleCloseModal();
    }
  };

  return (
    <Adminlayout>
    <Container fluid className="disputes-container">
      {/* Header Section */}
    <TitleBar
    title="NGO/Donor Disputes"
    subtitle="Manage disputes and conflicts between students and donors"
    ></TitleBar>
      {/* Search and Filter Section */}
      <div className="search-filter-section">
          <Card className="Disputes-filter-card mb-4">
          <Card.Body>
            <Row className="align-items-center">
              <Col lg={8} md={4} className="mb-3 mb-lg-0">
                <InputGroup>
                  <InputGroup.Text className="Disputes-search-icon">
                    <FaSearch />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search Disputes by name ..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="Disputes-search-input"
                  />
                </InputGroup>
              </Col>

              <Col lg={3} md={6} className="mb-3 mb-lg-0">
                <InputGroup>
                  <InputGroup.Text className="Disputes-filter-icon">
                    <FaFilter />
                  </InputGroup.Text>
                  <Form.Select

                      className="filter-dropdown"
                      value={filterType}
                      onChange={(e) => setFilterType(e.target.value)}
                    >
                      <option value="All">All Disputes</option>
                      <option value="Donor">Donor Disputes</option>
                      <option value="NGO">NGO Disputes</option>
                      <option value="Student">Student Disputes</option>
                  </Form.Select>
                </InputGroup>
              </Col>

            </Row>
          </Card.Body>
        </Card>
        
        {/* Filter Dropdown */}
           {/* <div className="filter-dropdown-wrapper">
          <select
            className="filter-dropdown"
             value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
           >
            <option value="All">All Disputes</option>
            <option value="Donor">Donor Disputes</option>
            <option value="NGO">NGO Disputes</option>
          </select>
        </div>  */}
      </div>   

      {/* Disputes Table */}
      <div className="disputes-table-card">
        {currentDisputes.length > 0 ? (
          <>
            <Table responsive className="disputes-table">
              <thead>
                <tr>
                  <th>Student</th>
                  <th>Donor/NGO</th>
                  <th>Reported By</th>
                  <th>Reason</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentDisputes.map((dispute) => (
                  <tr key={dispute.id}>
                    <td className="student-name-cell">{dispute.studentName}</td>
                    <td className="donor-name-cell">{dispute.donorName}</td>
                    <td>
                    <span
                         className={`reported-by-badge ${
                         dispute.reportedBy === "Donor"
                          ? "reported-donor"
                          : dispute.reportedBy === "NGO"
                          ? "reported-ngo"
                          : "reported-student"
                       }`}
                       >
                      {dispute.reportedBy}
                    </span>

                    </td>
                    <td className="reason-cell">{dispute.reason}</td>
                    <td>
                      <span
                        className={`status-badge ${
                          dispute.status === 'Pending'
                            ? 'status-pending'
                            : dispute.status === 'Resolved'
                            ? 'status-resolved'
                            : 'status-blocked'
                        }`}
                      >
                        {dispute.status}
                      </span>
                    </td>
                    <td>
                      <div className="action-buttons">
                        <button
                          className="btn-view"
                          onClick={() => handleViewDetails(dispute)}
                        >
                         <Eye size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            {/* Pagination */}
            {filteredDisputes.length > itemsPerPage && (
              <div className="pagination-container">
                <div className="pagination-info">
                  Showing {startIndex + 1} to {Math.min(endIndex, filteredDisputes.length)} of {filteredDisputes.length} disputes
                </div>
                <div className="pagination-buttons">
                  <button
                    className="pagination-btn"
                    onClick={goToPrevPage}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>
                  
                  <div className="page-numbers">
                    {getPageNumbers().map((page) => (
                      <button
                        key={page}
                        className={`page-number-btn ${currentPage === page ? 'active' : ''}`}
                        onClick={() => goToPage(page)}
                      >
                        {page}
                      </button>
                    ))}
                  </div>
                  
                  <button
                    className="pagination-btn"
                    onClick={goToNextPage}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="empty-state">
            <div className="empty-state-icon">📋</div>
            <p className="empty-state-text">No disputes found</p>
          </div>
        )}
      </div>

      {/* View Details Modal */}
      {showModal && selectedDispute && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div
            className="modal-content-custom"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div className="modal-header-custom">
              <h2 className="modal-title-custom">Complaint Details</h2>
            </div>

            {/* Modal Body */}
            <div className="modal-body-custom">
              <div className="detail-row">
                <div className="detail-label">Student Name</div>
                <div className="detail-value detail-value-highlight">
                  {selectedDispute.studentName}
                </div>
              </div>

              <div className="detail-row">
                <div className="detail-label">Donor/NGO Name</div>
                <div className="detail-value detail-value-highlight">
                  {selectedDispute.donorName}
                </div>
              </div>

              <div className="detail-row">
                <div className="detail-label">Reported By</div>
                <div className="detail-value">
                <span
                        className={`reported-by-badge-large ${
                        selectedDispute.reportedBy === "Donor"
                        ? "reported-donor"
                        : selectedDispute.reportedBy === "NGO"
                        ? "reported-ngo"
                        : "reported-student"
                        }`}
                      >
                     {selectedDispute.reportedBy}
                  </span>

                </div>
              </div>

              <div className="detail-row">
                <div className="detail-label">Reason</div>
                <div className="detail-value">{selectedDispute.reason}</div>
              </div>

              <div className="detail-row">
                <div className="detail-label">Date</div>
                <div className="detail-value">{selectedDispute.date}</div>
              </div>

              {/* Donor/NGO Message */}
              <div className="donor-message-section">
                <div className="donor-message-label">{selectedDispute.reportedBy} Message:</div>
                <p className="donor-message-text">
                  "{selectedDispute.donorMessage}"
                </p>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="modal-footer-custom">
              <button
                className="btn-warn"
                onClick={() => handleWarnStudent(selectedDispute.studentName)}
              >
                Warn Student
              </button>
              <button
                className="btn-block"
                onClick={() => handleBlockStudent(selectedDispute.studentName)}
              >
                Block Student
              </button>
              <button className="btn-close-modal" onClick={handleCloseModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </Container>
    </Adminlayout>
  );
};

export default StudentDisputes;